module.exports = __webpack_public_path__ + "img/616-42dfb3.png";